import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSendMessage } from 'shared/hooks';

interface UseDeleteProfileDialogsReturn {
    open: boolean;
    title: string;
    message: string;
    confirmText?: string;
    closeText: string;
    isLoading?: boolean;
    onConfirm?: () => void;
    onClose: () => void;
    onOpen: () => void;
}

export default function useDeleteProfileDialogs(): UseDeleteProfileDialogsReturn {
    const { t } = useTranslation('profile');
    const [ showDialog, setShowDialog ] = useState(false);
    const [ dialogState, setDialogState ] = useState<'confirm' | 'success' | 'error' | null>(null);

    const { mutate: requestDeletion, isPending } = useSendMessage();

    const handleOpen = () => {
        setShowDialog(true);
        setDialogState('confirm');
    };

    const handleClose = () => {
        setShowDialog(false);
    };

    if (dialogState === 'confirm') {
        return {
            title: t('deleteRequest.confirmDialog.title'),
            message: t('deleteRequest.confirmDialog.message'),
            confirmText: t('deleteRequest.confirmDialog.confirm'),
            closeText: t('deleteRequest.confirmDialog.cancel'),
            isLoading: isPending,
            onConfirm: () => {
                requestDeletion(
                    { type: 'ProfileDeletionRequest', payload: {} },
                    {
                        onSuccess: () => setDialogState('success'),
                        onError: () => setDialogState('error')
                    }
                );
            },
            onClose: handleClose,
            onOpen: handleOpen,
            open: showDialog
        };
    }

    if (dialogState === 'success') {
        return {
            title: t('deleteRequest.successDialog.title'),
            message: t('deleteRequest.successDialog.message'),
            closeText: t('deleteRequest.successDialog.close'),
            onClose: handleClose,
            onOpen: handleOpen,
            open: showDialog
        };
    }

    return {
        title: t('deleteRequest.error.title'),
        message: t('deleteRequest.error.message'),
        closeText: t('deleteRequest.error.close'),
        onClose: handleClose,
        onOpen: handleOpen,
        open: showDialog
    };
}
